<template lang="pug">
  transition-group.fondo(name="fade-smooth")
    lista-reclamaciones.lista(
      @selected="seleccionarReclamacion"
      key="lista"
      ref="lista"
    )
    .respuesta(
      v-if="preimpreso"
      key="respuesta"
    )
      .header
        .text
          p 
            span Seleccionado 
            strong {{ preimpreso }}
        .close(
          @click="preimpreso = ''"
        )
          span.icon
            i.fa.fa-times
      .body
        .field
          label.label 
            | Respuesta a la reclamación
          .control
            textarea.textarea(
              rows='5', 
              v-model="respuesta"
              placeholder="Ingrese la respuesta que quiere dar a la reclamación"
            )
        .acciones
          button.button.is-empresa.button-responder(
            @click="enviarRespuesta"
            :class="{ 'is-loading': isSending }"
          ) Enviar respuesta
          button.button.bd-color-empresa.fc-empresa(
            @click="preimpreso=''"
          ) Cancelar
</template>

<script>
import ListaReclamaciones from './Component-lista-reclamaciones.vue'
import { apiPost, notify } from '../util/general'
export default {
  name: 'responder',
  components: {
    ListaReclamaciones
  },
  data () {
    return {
      preimpreso: '',
      dni: '',
      respuesta: '',
      isSending: false
    }
  },
  created () {
  },
  methods: {
    seleccionarReclamacion (o) {
      console.log('o:', o)
      this.preimpreso = o.preimpreso
      this.dni        = o.dni
    },
    enviarRespuesta () {
      let vm = this
      vm.isSending = true
      let obj = {
        preimpreso : vm.preimpreso,
        respuesta  : vm.respuesta
      }

      if (!obj.respuesta) {
        vm.isSending = false
        notify(vm, 'error', 'Error', 'Por favor ingrese una respuesta')
        return
      }
      apiPost(vm, '/libroreclamaciones/respuesta', obj, function (data) {
        vm.isSending = false
        notify(vm, 'success', 'Éxito', 'La reclamación fue respondida exitosamente')
        var url = process.env.API_ROUTE + '/libroreclamaciones/pdf?empresa=' + process.env.EMPRESA + '&preimpreso=' + vm.preimpreso + '&dni=' + vm.dni
        console.log('url:', url)
        var link    = document.createElement('a');
        link.href   = url
        link.target = '_blank'
        link.click();
        vm.preimpreso = ''
        vm.dni = ''
        vm.respuesta = ''
        vm.$refs.lista.fetch() // Direct call fetch method
      }, function (error) {
        console.log(error);
        vm.isSending = false
        notify(vm, 'error', 'Error', 'Su respuesta no pudo ser enviada')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .fondo
    height calc(100vh - 52px)
    overflow hidden
    text-align left
    display flex
    flex-direction column
    >*
      transition all .5s ease
    .lista
      flex 1
      overflow-x auto
      padding 20px 10px 0px 10px
    .respuesta
      z-index 1
      overflow-x auto
      flex 1
      // border-top 1px solid #ccc
      background-color #eaeaea
      box-shadow: 1px 1px 4px 2px #ccc;
      .header
        display flex
        padding 5px
        border-bottom 1px solid #ccc
        .text
          flex 1
        .close
          cursor pointer
    
  .body
    padding 10px
    .control
      padding 20px
    .acciones
      display flex
      justify-content center
      .button
        margin-left 5px
</style>



// WEBPACK FOOTER //
// View_Responder.vue?0ad7f5a6